import React, { useState } from "react";

import {
    Avatar,
    Box,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    List,
    ListItemButton,
    ListItemAvatar,
    ListItemText,
    TextField,
    Typography,
    Divider,
    IconButton,
} from "@mui/material";

import BusinessIcon from "@mui/icons-material/Business";
import PersonIcon from "@mui/icons-material/Person";
import CloseIcon from "@mui/icons-material/Close";

import api from "../../api";

const AdvancedSearchDialog = ({
    open,
    type,
    enterpriseId,
    onClose,
    onSelect,
}) => {

    const [query, setQuery] = useState("");
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState(null);

    const handleSearch = async () => {
        if (!query.trim() || loading) return;

        setLoading(true);

        try {
            const url =
                type === "contact"
                    ? `/api/enterprises/${enterpriseId}/contacts/advanced_search/?search=${encodeURIComponent(query)}`
                    : `/api/enterprises/${enterpriseId}/contact_enterprises/advanced_search/?search=${encodeURIComponent(query)}`;

            const res = await api.get(url);

            if (res.status === 200) {
                setResults(res.data);
            } else {
                setResults([]);
            }
        } finally {
            setLoading(false);
        }
    };

    const getMatchingValue = (values = [], query = "") => {
      if (!values.length) return null;

      const normalizedQuery = query.trim().toLowerCase();

      return (
        values.find(value =>
          value.toLowerCase().includes(normalizedQuery)
        ) ?? values[0]
      );
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                {type === "contact"
                    ? "Pesquisar contato"
                    : "Pesquisar empresa"}

                <IconButton onClick={onClose}>
                  <CloseIcon />
                </IconButton>
            </DialogTitle>

            <Divider />

            <DialogContent>

                <Box
                    sx={{
                        display: "flex",
                        gap: 1,
                        paddingTop: 1
                    }}
                >
                    <TextField
                        size="small"
                        autoFocus
                        fullWidth
                        placeholder="Busque por nome, telefone ou e-mail..."
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                handleSearch();
                            }
                        }}
                    />

                    <Button
                        sx={{ minWidth: "8rem" }}
                        size="small"
                        variant="contained"
                        onClick={handleSearch}
                        disabled={loading || !query.trim()}
                        startIcon={
                            loading
                                ? <CircularProgress size={18} color="inherit" />
                                : null
                        }
                    >
                        Pesquisar
                    </Button>
                </Box>

                <Box sx={{ mt: 2 }}>

                    {!loading && results !== null && (
                        <List disablePadding>

                            {results.length === 0 && (
                                <Typography
                                    color="text.secondary"
                                    sx={{
                                        textAlign: "center",
                                        py: 4,
                                    }}
                                >
                                    Nenhum resultado encontrado.
                                </Typography>
                            )}

                            {results.map((item) => (
                                <ListItemButton
                                    key={item.id}
                                    onClick={() => {
                                        onSelect(item);
                                        onClose();
                                    }}
                                >
                                    <ListItemAvatar>
                                        <Avatar>
                                            {type === "contact"
                                                ? <PersonIcon />
                                                : <BusinessIcon />}
                                        </Avatar>
                                    </ListItemAvatar>

                                    <ListItemText
                                        primary={item.name}
                                        secondary={
                                          type === "contact"
                                          ? [getMatchingValue(item.emails, query), getMatchingValue(item.telephones, query)].filter(Boolean).join(" • ")
                                          : [item.email, item.telephone].filter(Boolean).join(" • ")
                                        }
                                    />
                                </ListItemButton>
                            ))}

                        </List>
                    )}

                </Box>

            </DialogContent>

        </Dialog>
    );
};

export default AdvancedSearchDialog;